import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
  min-height: 72px;
  padding: 0.75rem 1.25rem 0.75rem 0.75rem;
  text-align: left;
  background: var(--color-neutral-dark);
  border: 1px solid transparent;
  border-radius: 1rem;
  transition:
    border-color 0.15s,
    background-color 0.15s;

  &:hover {
    border-color: var(--color-neutral-base);
  }

  &:focus-visible {
    outline: 2px solid var(--color-brand-plus);
    outline-offset: 2px;
  }

  .leading {
    display: flex;
    flex-shrink: 0;

    /* The Keepo thumbnail, smaller than on the Keepos list */
    > div {
      width: 48px;
      height: 48px;
      border-radius: 10px;
    }
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
  }

  .title,
  .subtitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .title {
    font-family: Inter, sans-serif;
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
  }

  .subtitle {
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    line-height: 1.125rem;
    color: var(--color-neutral-150);
  }

  .radio-input-container {
    flex-shrink: 0;
  }

  &.dashed {
    background: transparent;
    border: 2px dashed var(--color-neutral-base);

    &:hover {
      border-color: var(--color-neutral-light);
    }
  }

  &.active {
    background:
      radial-gradient(120% 160% at 0% 0%, rgba(87, 242, 139, 0.12) 0%, rgba(87, 242, 139, 0) 60%),
      var(--color-neutral-dark);
    border: 1px solid var(--color-brand-plus);

    .radio-input-container {
      border-color: var(--color-brand-plus);
    }

    .radio-input-content {
      background-color: var(--color-brand-plus);
    }
  }
`;
